import { offersUnit, purchasedUnit } from '../../state';
import { TESTATE, STEPS } from '../../lib/constants';
import { getTestata, goToHref } from '../../lib/utils';

const subscriptionTypes = {
  month: 'SUBS1',
  year: 'SUBS12',
};

const stringWithDecimal = (value) => (Number(value) / 100 ).toFixed(2);
const testataName = TESTATE[getTestata()].title;

const getSelectedOfferStripe = (selectedOfferId, offers) =>
  offers.find((offer) => offer.id === selectedOfferId) || {};

const getAndMapOffers = (offers) =>
  offers.map((offer) => ({
    name: offer.nickname,
    id: subscriptionTypes[offer.interval],
    brand: testataName,
    price:
      (offer.graduateAmount && stringWithDecimal(offer.graduateAmount[0].unit_amount_decimal)) ||
      offer.amount,
    category: 'Subscription',
    quantity: 1,
  }));

const gtmEventsType = {
  [STEPS.waiting]: {
    gtmEvent: null,
    gtmEventStep: 0,
  },
  [STEPS.logged]: {
    gtmEvent: null,
    gtmEventStep: 0,
  },
  [STEPS.notlogged]: {
    gtmEvent: null,
    gtmEventStep: 0,
  },
  [STEPS.subscribed]: {
    gtmEvent: null,
    gtmEventStep: 0,
  },
  [STEPS.offers]: {
    gtmEvent: 'checkout',
    gtmEventStep: 1,
  },
  [STEPS.payment]: {
    gtmEvent: 'checkout',
    gtmEventStep: 2,
  },
  [STEPS.thankyou]: {
    gtmEvent: 'purchase',
  },
};

// torna una funziona per non farla applicare subito
const trackAndGoToHref = (href, auth0, offersFromUC) => () => {
  const paymentStatus = auth0?.paymentStatus;
  const eventData = {
    event: 'checkout',
    userStatus: paymentStatus || auth0.loginStatus, // anonymous, registered, subscriber
    ecommerce: {
      checkout: {
        products: getAndMapOffers([offersFromUC]),
        actionField: { step: 1 },
      },
    },
  };
  window.dataLayer.push(eventData);
  return goToHref(href)();
};

export { trackAndGoToHref };

export function dataLayerEvents(value, selectedOfferId) {
  const offersFromUnit = offersUnit.value();
  const offersPurchased = purchasedUnit.value();
  const offers = getAndMapOffers(offersFromUnit);
  const { gtmEvent = '', gtmEventStep = '' } = gtmEventsType[value];

  if (!gtmEvent) {
    return;
  }

  let eventData = {};
  if (gtmEvent === 'checkout') {
    eventData.userStatus = 'Registered';
    eventData.ecommerce = {};
    eventData = { event: gtmEvent, ecommerce: { [gtmEvent]: { products: offers } } };
    eventData.ecommerce[gtmEvent].actionField = { step: gtmEventStep };

    if (gtmEventStep === 2) {
      if (!selectedOfferId) {
        return;
      }
      const selectedOfferStripe = getSelectedOfferStripe(selectedOfferId, offersFromUnit);
      const amount =
        (selectedOfferStripe.graduateAmount &&
          stringWithDecimal(selectedOfferStripe.graduateAmount[0].unit_amount_decimal)) ||
        selectedOfferStripe.amount;
      eventData.ecommerce[gtmEvent].products = [
        {
          name: selectedOfferStripe.nickname,
          id: subscriptionTypes[selectedOfferStripe.interval],
          price: amount,
          brand: testataName,
          category: 'Subscription',
          quantity: 1,
        },
      ];
    }
  }

  if (gtmEvent === 'purchase') {
    eventData = { event: gtmEvent, ecommerce: { [gtmEvent]: {} } };
    eventData.userStatus = 'Subscriber';
    eventData.ecommerce[gtmEvent].actionField = {
      id: offersPurchased.id,
      revenue: stringWithDecimal(offersPurchased.latest_invoice.amount_paid),
    };
    const purchasedPlanName = offersFromUnit.find((offer) => offer.id === offersPurchased.plan.id).name;
    eventData.ecommerce[gtmEvent].products = [
      {
        name: purchasedPlanName,
        id: subscriptionTypes[offersPurchased.plan.interval],
        price: stringWithDecimal(offersPurchased.latest_invoice.amount_paid),
        brand: testataName,
        category: 'Subscription',
        quantity: 1,
      },
    ];
    for (const d of window.dataLayer) {
      if ('Id_Id' in d) {
        eventData.ecommerce[gtmEvent].actionField.affiliation = d.Id_Id;
      }
    }
  }
  window.dataLayer.push(eventData);
}
